import { PostUserToUserIdGiftResponse } from "./postResponse"
import { UserToUserIdGiftInputModel } from "./PostInputModel"
import { httpPost } from "../../../../../libs/http/httpPost"

export const postUserToUserIdGift = async (
  model: UserToUserIdGiftInputModel,
): Promise<PostUserToUserIdGiftResponse> => {
  return httpPost<PostUserToUserIdGiftResponse>(
    "/v1/user/{toUserId}/gift",
    model,
  )
}
